/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/compass-active': {
    width: 69,
    height: 69,
    viewBox: '0 0 69 69',
    data: '<circle pid="0" cx="34.13" cy="34.13" r="32.63" _fill="#fff" _stroke="#000" stroke-width="3"/><path id="nord-arrow" pid="1" d="M34 6l7 27.77H27L34 6z" _fill="#000"/><path pid="2" d="M34 61.539l-7-27.77h14l-7 27.77z" _fill="#000"/><circle pid="3" cx="34" cy="34" r="3" _fill="#fff"/>'
  }
})
